export function toFilename(filename: string, extension: string): string {
  filename = filename.replace(/[\/\s]+/g, '-').replace(/[^\w-]/g, ''); // eslint-disable-line no-useless-escape
  return `${filename}.${extension}`;
}

/**
 * Given a filename ('hello.txt'), returns {root: 'hello', 'extension': '.txt'}. This matches the
 * os.path.splitext contract from Python (e.g., ignores leading periods - '.bashrc' returns
 * {root: '.bashrc', extension: ''})
 */
export function splitExtension(filename: string): {root: string; extension: string} {
  const lastIndex = filename.lastIndexOf('.');
  if (lastIndex === 0 || lastIndex === -1) {
    return {root: filename, extension: ''};
  } else {
    return {root: filename.slice(0, lastIndex), extension: filename.slice(lastIndex)};
  }
}
